const PX_TOKEN_REGEX = /-?\d*\.?\d+(?:px|rem|em)/g;

const toPx = (token) => {
  if (typeof token === 'number') {
    return token;
  }

  if (typeof token !== 'string') {
    return undefined;
  }

  const trimmed = token.trim();

  if (/^-?\d*\.?\d+$/.test(trimmed)) {
    return Number(trimmed);
  }

  const match = trimmed.match(/^(-?\d*\.?\d+)(px|rem|em)$/);

  if (!match) {
    return undefined;
  }

  const value = Number(match[1]);
  const unit = match[2];

  if (unit === 'px') {
    return value;
  }

  if (unit === 'rem' || unit === 'em') {
    return value * 16;
  }

  return undefined;
};

const getTrackingForSize = (fontSizePx) => {
  if (!Number.isFinite(fontSizePx)) {
    return undefined;
  }

  if (fontSizePx >= 20) {
    return '-0.03em';
  }

  if (fontSizePx >= 16) {
    return '-0.02em';
  }

  if (fontSizePx >= 14) {
    return '-0.01em';
  }

  return '-0.002em';
};

export const headingLetterSpacing = (fontSize) => {
  if (fontSize == null) {
    return undefined;
  }

  if (Array.isArray(fontSize)) {
    return fontSize.map((value) => headingLetterSpacing(value));
  }

  if (typeof fontSize === 'object') {
    return Object.fromEntries(
      Object.entries(fontSize).map(([key, value]) => [
        key,
        headingLetterSpacing(value),
      ])
    );
  }

  if (typeof fontSize === 'number') {
    return getTrackingForSize(fontSize);
  }

  const matches = String(fontSize).match(PX_TOKEN_REGEX);

  if (matches && matches.length) {
    const pxValue = Math.max(
      ...matches.map((token) => toPx(token)).filter(Number.isFinite)
    );
    return getTrackingForSize(pxValue);
  }

  const numericValue = toPx(fontSize);

  return getTrackingForSize(numericValue);
};
